<template>
    <div>
        <!-- Legende -->
        <div class="d-flex justify-content-center align-items-center gap-4 mb-6">
            <div class="d-flex align-items-center">
                <span class="badge bg-success mr-2 pt-1">&nbsp;</span>
                {{ __(`statistics.price_comparison.${PriceSegment.BELOW_COMPARISON}`) }}
            </div>
            <div class="d-flex align-items-center">
                <span class="badge bg-warning mr-2 pt-1">&nbsp;</span>
                {{ __(`statistics.price_comparison.${PriceSegment.IN_COMPARISON}`) }}
            </div>
            <div class="d-flex align-items-center">
                <span class="badge bg-danger mr-2 pt-1">&nbsp;</span>
                {{ __(`statistics.price_comparison.${PriceSegment.ABOVE_COMPARISON}`) }}
            </div>
        </div>
        <div class="progress mx-10" style="height: 30px;">
            <div
                class="progress-bar bg-success text-black text-lg"
                role="progressbar"
                :style="{ width: `${belowMinCount / (belowMinCount + inRangeCount + aboveMaxCount) * 100}%` }"
                :aria-valuenow="belowMinCount"
                aria-valuemin="0"
                aria-valuemax="100"
            >
                {{ belowMinCount }}
            </div>
            <div
                class="progress-bar bg-warning text-black text-lg"
                role="progressbar"
                :style="{ width: `${inRangeCount / (belowMinCount + inRangeCount + aboveMaxCount) * 100}%` }"
                :aria-valuenow="inRangeCount"
                aria-valuemin="0"
                aria-valuemax="100"
            >
                {{ inRangeCount }}
            </div>
            <div
                class="progress-bar bg-danger text-black text-lg"
                role="progressbar"
                :style="{ width: `${aboveMaxCount / (belowMinCount + inRangeCount + aboveMaxCount) * 100}%` }"
                :aria-valuenow="aboveMaxCount"
                aria-valuemin="0"
                aria-valuemax="100"
            >
                {{ aboveMaxCount }}
            </div>
        </div>
    </div>
</template>

<script>
import {PriceSegment} from '@generated/priceSegment';

export default {
    computed: {
        PriceSegment() {
            return PriceSegment
        }
    },
    props: {
        belowMinCount: {
            type: Number,
            default: 0,
        },
        inRangeCount: {
            type: Number,
            default: 0,
        },
        aboveMaxCount: {
            type: Number,
            default: 0,
        },
    },
};
</script>
